import { render, staticRenderFns } from "./DeliveryTemplateForm.vue?vue&type=template&id=1c6858b4&scoped=true&"
import script from "./DeliveryTemplateForm.vue?vue&type=script&lang=ts&"
export * from "./DeliveryTemplateForm.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryTemplateForm.vue?vue&type=style&index=0&id=1c6858b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6858b4",
  null
  
)

export default component.exports